import { TRANSPARENT, getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  title: 'This is a header for a section...',
  subTitle: 'This is the subTitle...',
  backgroundColor: TRANSPARENT,
  hideTopPadding: false,
  hideBottomPadding: false,
  gridContainerProps: {},
  gridRowProps: {},
  gridColProps: {},
  withParentCardWrapper: false,
  withChildrenCardWrapper: false,
  parentCardNoPadding: false,
  childrenCardNoPadding: false,
  alignCenterTitle: {
    desktop: false,
    mobile: true
  },
  alignCenterChildren: {
    desktop: true,
    mobile: false
  },
  titleSize: {
    mobile: 'lg'
  },
  subTitleSize: {
    mobile: 'md'
  }
}, getTestId('TitleSectionContainer'));